import React, { useState, useMemo } from 'react';
import './dashboard.css';
import { deriveSubdomainSlug } from '../utils/subdomainFallback';

// ─── Inline SVG icons (matching design) ──────────────────────────────────────
const I = {
  globe:     (p) => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" {...p}><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18"/></svg>,
  share:     (p) => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" {...p}><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="m8.6 13.5 6.8 4M15.4 6.5l-6.8 4"/></svg>,
  dots:      (p) => <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" {...p}><circle cx="12" cy="5" r="1.6"/><circle cx="12" cy="12" r="1.6"/><circle cx="12" cy="19" r="1.6"/></svg>,
  search:    (p) => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>,
  external:  (p) => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M15 3h6v6"/><path d="M10 14 21 3"/><path d="M21 14v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5"/></svg>,
  arrowRight:(p) => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M5 12h14M13 5l7 7-7 7"/></svg>,
  trend:     (p) => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="m22 7-8.5 8.5-5-5L2 17"/><path d="M16 7h6v6"/></svg>,
  eye:       (p) => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8S1 12 1 12Z"/><circle cx="12" cy="12" r="3"/></svg>,
  contacts:  (p) => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
  leads:     (p) => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="m17 11 2 2 4-4"/></svg>,
  filter:    (p) => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M22 3H2l8 9.5V19l4 2v-8.5Z"/></svg>,
  template:  (p) => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" {...p}><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 21V9"/></svg>,
  home:      (p) => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2h-4v-7H9v7H5a2 2 0 0 1-2-2Z"/></svg>,
  domain:    (p) => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" {...p}><circle cx="12" cy="12" r="9"/><path d="M3.6 9h16.8M3.6 15h16.8M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18"/></svg>,
  blog:      (p) => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M11 4H5a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2v-6"/><path d="M18.5 2.5a2.121 2.121 0 1 1 3 3L12 15l-4 1 1-4Z"/></svg>,
  sparkle:   (p) => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M5.6 18.4l2.1-2.1M16.3 7.7l2.1-2.1"/></svg>,
  menu:      (p) => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M3 6h18M3 12h18M3 18h18"/></svg>,
  layout:    (p) => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" {...p}><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 21V9"/></svg>,
  info:      (p) => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" {...p}><circle cx="12" cy="12" r="9"/><path d="M12 16v-4M12 8h.01"/></svg>,
};

// ─── Seeded analytics data (used when real data is empty) ─────────────────────
function seedSeries(seed, n, base, amp) {
  const out = [];
  let s = seed;
  for (let i = 0; i < n; i++) {
    s = (s * 9301 + 49297) % 233280;
    const r = s / 233280;
    const trend = i / n;
    out.push(Math.max(0, Math.round(base + base * trend * 0.6 + (r - 0.4) * amp)));
  }
  return out;
}

function dateLabel(i, n) {
  const d = new Date();
  d.setDate(d.getDate() - (n - 1 - i));
  return `${d.getMonth() + 1}/${d.getDate()}`;
}

const RANGES = {
  '7days':  { label: 'Last 7 days',  key: '7d',  n: 7 },
  '30days': { label: 'Last 30 days', key: '30d', n: 30 },
  '90days': { label: 'Last 90 days', key: '90d', n: 90 },
};

// ─── Sub-components ───────────────────────────────────────────────────────────

function Attr({ icon, label, value, link, badge }) {
  return (
    <div className="dx-attr">
      <div className="dx-attr-icon">{icon}</div>
      <div>
        <div className="dx-attr-label">{label}</div>
        <div className="dx-attr-value">
          <span className={link ? 'dx-attr-link' : ''}>{value}</span>
          {badge && <span className="dx-badge">{badge}</span>}
        </div>
      </div>
    </div>
  );
}

function Stat({ label, value, delta, up }) {
  return (
    <div className="dx-stat">
      <div className="dx-stat-label">{label}</div>
      <div className="dx-stat-row">
        <div className="dx-stat-value">{value}</div>
        {delta && (
          <div className={`dx-stat-delta ${up ? 'dx-stat-up' : 'dx-stat-down'}`}>
            <I.trend style={{ transform: up ? 'none' : 'rotate(180deg) scaleX(-1)' }} />
            {delta}
          </div>
        )}
      </div>
    </div>
  );
}

// "vs yesterday" for a real-data today/yesterday pair -- no fallback to a
// fabricated percentage when there's nothing to compare against yet.
function dayDelta(today, yesterday) {
  if (yesterday === 0) return null;
  const pct = ((today - yesterday) / yesterday) * 100;
  return { delta: `${pct > 0 ? '+' : ''}${pct.toFixed(1)}%`, up: pct >= 0 };
}

function SiteCard({ dashboardData, user, currentSubdomain }) {
  const subdomain  = deriveSubdomainSlug(user, currentSubdomain);
  const domain = dashboardData?.websiteInfo?.domain
    || currentSubdomain?.name
    || (subdomain ? `${subdomain}.users.godreamx.com` : 'Not set up yet');
  const template   = dashboardData?.websiteInfo?.template   || 'Not published yet';
  const pkg        = dashboardData?.packageInfo?.packageName || 'Free';
  const status     = dashboardData?.websiteInfo?.status      || 'pending';
  const mlsFeeds   = dashboardData?.mlsConnections || [];
  const orgName    = user?.org
    ? (typeof user.org === 'string' ? user.org : (user.org).name)
    : 'Demo Realty';
  const userName   = [user?.firstName, user?.lastName].filter(Boolean).join(' ') || 'Demo User';

  const liveUrl    = subdomain ? `https://${subdomain}.users.godreamx.com` : null;

  // Last two entries of the real daily series are always today/yesterday --
  // the backend returns exactly N oldest-first daily buckets. See issue #15.
  const series     = dashboardData?.analytics || [];
  const today      = series[series.length - 1];
  const yesterday  = series[series.length - 2];
  const visitorsDelta = yesterday ? dayDelta(today?.uniqueVisitors || 0, yesterday.uniqueVisitors || 0) : null;
  const leadsDelta    = yesterday ? dayDelta(today?.registeredLeads || 0, yesterday.registeredLeads || 0) : null;

  return (
    <div className="dx-site-card">
      {/* Left: browser preview mockup */}
      <div className="dx-site-preview">
        <div className="dx-site-preview-inner">
          <div className="dx-sp-browser">
            <span /><span /><span />
          </div>
          <div className="dx-sp-hero">
            <div className="dx-sp-hero-tag">FEATURED</div>
            <div className="dx-sp-hero-h">Find your dream home in Dayton.</div>
            <div className="dx-sp-hero-sub">Browse 2,400+ active listings across Ohio.</div>
            <div className="dx-sp-search">
              <I.search />
              <span className="dx-sp-search-flex">Search by city, zip…</span>
              <span className="dx-sp-search-btn">Search</span>
            </div>
          </div>
          <div className="dx-sp-cards">
            {[0,1,2].map(i => (
              <div key={i} className="dx-sp-mini">
                <div className="dx-sp-mini-img" />
                <div className="dx-sp-mini-row" />
                <div className="dx-sp-mini-row-sm" />
              </div>
            ))}
          </div>
        </div>
        <div className="dx-site-preview-overlay">
          {liveUrl && (
            <button className="dx-btn dx-btn-glass" onClick={() => window.open(liveUrl, '_blank')}>
              <I.external /> Visit site
            </button>
          )}
        </div>
      </div>

      {/* Right: site metadata */}
      <div className="dx-site-meta">
        <div>
          <div className="dx-site-title-row">
            <h1>{domain}</h1>
            <span className="dx-site-status">
              <span className="dx-dot" style={{ background: '#10b981' }} />
              {status.charAt(0).toUpperCase() + status.slice(1)}
            </span>
            {liveUrl && (
              <button className="dx-icon-btn" title="Share" onClick={() => navigator.clipboard?.writeText(liveUrl)}>
                <I.share />
              </button>
            )}
            <button className="dx-icon-btn" title="More" style={{ marginLeft: 'auto' }}>
              <I.dots />
            </button>
          </div>
          <div className="dx-site-sub">{orgName} — {userName}</div>
        </div>

        <div className="dx-attrs">
          <Attr icon={<I.template />} label="Template" value={template} link />
          <Attr icon={<I.home />}     label="Package"  value={pkg}      badge="SEO" />
          <Attr icon={<I.domain />}   label="Domain"   value={domain}   link />
        </div>

        <div>
          <div className="dx-mls-label">MLS Feeds</div>
          <div className="dx-chips">
            {mlsFeeds.length > 0 ? (
              mlsFeeds.map((mls, i) => (
                <span key={i} className="dx-chip">
                  <span className="dx-chip-dot" />
                  {mls.name} ({mls.code})
                </span>
              ))
            ) : (
              <span className="dx-chip-empty">No MLS feeds connected yet</span>
            )}
            <button className="dx-chip dx-chip-add">+ Add feed</button>
          </div>
        </div>

        <div className="dx-stats">
          <Stat label="Visitors today" value={(today?.uniqueVisitors || 0).toLocaleString()} delta={visitorsDelta?.delta} up={visitorsDelta?.up} />
          <Stat label="New leads today" value={(today?.registeredLeads || 0).toLocaleString()} delta={leadsDelta?.delta} up={leadsDelta?.up} />
        </div>
      </div>
    </div>
  );
}

function Analytics({ dashboardData, analyticsTimeRange, onTimeRangeChange }) {
  const [metric, setMetric] = useState('views');
  const rangeCfg = RANGES[analyticsTimeRange] || RANGES['7days'];

  // Use real data if available, otherwise seed
  const series = useMemo(() => {
    const realData = dashboardData?.analytics;
    if (realData && realData.length > 0) {
      return realData.map(d =>
        metric === 'views'    ? (d.pageViews || 0) :
        metric === 'visitors' ? (d.uniqueVisitors || 0) :
                                (d.registeredLeads || 0)
      );
    }
    const seedBase = { views: 137, visitors: 53, leads: 11 }[metric];
    const amp      = { views: 80,  visitors: 40, leads: 8  }[metric];
    const seedKey  = seedBase * (analyticsTimeRange === '7days' ? 1 : analyticsTimeRange === '30days' ? 2 : 3);
    return seedSeries(seedKey, rangeCfg.n, seedBase, amp);
  }, [metric, analyticsTimeRange, dashboardData, rangeCfg.n]);

  const prevSeries = useMemo(() => {
    const base = { views: 120, visitors: 46, leads: 9 }[metric];
    const amp  = { views: 60,  visitors: 30, leads: 6 }[metric];
    return seedSeries(99, rangeCfg.n, base, amp);
  }, [metric, rangeCfg.n]);

  const max      = Math.max(...series, 1);
  const total    = series.reduce((a, b) => a + b, 0);
  const prevTotal = prevSeries.reduce((a, b) => a + b, 0);
  const deltaPct = prevTotal === 0 ? 0 : ((total - prevTotal) / prevTotal) * 100;

  // Each metric tile shows its OWN real total -- not a fabricated ratio of
  // whichever metric happens to be selected for the chart (previously
  // "Unique Visitors"/"Registered Leads" were always total*0.42/total*0.08
  // no matter what the real numbers were). See issue #15.
  const metricTotal = useMemo(() => {
    const realData = dashboardData?.analytics;
    const sum = (key) => {
      if (realData && realData.length > 0) {
        return realData.reduce((a, d) => a + (d[key] || 0), 0);
      }
      const seedBase = { pageViews: 137, uniqueVisitors: 53, registeredLeads: 11 }[key];
      const amp      = { pageViews: 80,  uniqueVisitors: 40, registeredLeads: 8  }[key];
      const seedKey  = seedBase * (analyticsTimeRange === '7days' ? 1 : analyticsTimeRange === '30days' ? 2 : 3);
      return seedSeries(seedKey, rangeCfg.n, seedBase, amp).reduce((a, b) => a + b, 0);
    };
    return { pageViews: sum('pageViews'), uniqueVisitors: sum('uniqueVisitors'), registeredLeads: sum('registeredLeads') };
  }, [dashboardData, analyticsTimeRange, rangeCfg.n]);

  // SVG chart dimensions
  const W = 720, H = 220;
  const P = { l: 36, r: 12, t: 16, b: 28 };
  const innerW = W - P.l - P.r;
  const innerH = H - P.t - P.b;
  const stepX  = innerW / Math.max(series.length - 1, 1);
  const pts    = series.map((v, i) => [
    P.l + i * stepX,
    P.t + innerH - (v / max) * innerH,
  ]);
  const linePath = pts.map((p, i) => (i === 0 ? 'M' : 'L') + p[0].toFixed(1) + ' ' + p[1].toFixed(1)).join(' ');
  const areaPath = linePath
    + ` L ${pts[pts.length - 1][0].toFixed(1)} ${(P.t + innerH).toFixed(1)}`
    + ` L ${pts[0][0].toFixed(1)} ${(P.t + innerH).toFixed(1)} Z`;

  const n = series.length;
  const xTicks = n <= 7
    ? series.map((_, i) => i)
    : [0, Math.floor(n * 0.25), Math.floor(n * 0.5), Math.floor(n * 0.75), n - 1];

  const metrics = [
    { id: 'views',    label: 'Page Views',        value: metricTotal.pageViews.toLocaleString(),      Icon: I.eye },
    { id: 'visitors', label: 'Unique Visitors',    value: metricTotal.uniqueVisitors.toLocaleString(), Icon: I.contacts },
    { id: 'leads',    label: 'Registered Leads',   value: metricTotal.registeredLeads.toLocaleString(), Icon: I.leads },
  ];

  const deltaStr = `${deltaPct > 0 ? '+' : ''}${deltaPct.toFixed(1)}% vs prev.`;
  const accent   = '#3b82f6';

  return (
    <section className="dx-card dx-analytics">
      <div className="dx-card-h">
        <div>
          <h2>Website Analytics</h2>
          <p className="dx-card-sub">Performance for {rangeCfg.label.toLowerCase()}</p>
        </div>
        <div className="dx-seg">
          {Object.entries(RANGES).map(([k, v]) => (
            <button
              key={k}
              className={`dx-seg-btn ${analyticsTimeRange === k ? 'active' : ''}`}
              onClick={() => onTimeRangeChange(k)}
            >
              {v.label.replace('Last ', '')}
            </button>
          ))}
        </div>
      </div>

      <div className="dx-metric-tabs">
        {metrics.map(({ id, label, value, Icon }) => (
          <button
            key={id}
            className={`dx-metric-tab ${metric === id ? 'active' : ''}`}
            onClick={() => setMetric(id)}
          >
            <div className="dx-metric-tab-h"><Icon /> <span>{label}</span></div>
            <div className="dx-metric-tab-v">{value}</div>
            <div className={`dx-metric-tab-d ${metric === id ? 'accent' : ''}`}
              style={metric === id ? { color: accent } : {}}
            >
              <I.trend /> {deltaStr}
            </div>
            {metric === id && <span className="dx-metric-tab-bar" style={{ background: accent }} />}
          </button>
        ))}
      </div>

      <div className="dx-chart-wrap">
        <svg viewBox={`0 0 ${W} ${H}`} className="dx-chart" preserveAspectRatio="none">
          <defs>
            <linearGradient id="dx-area-grad" x1="0" x2="0" y1="0" y2="1">
              <stop offset="0%"   stopColor={accent} stopOpacity="0.32" />
              <stop offset="100%" stopColor={accent} stopOpacity="0" />
            </linearGradient>
          </defs>

          {[0, 0.25, 0.5, 0.75, 1].map((f, i) => (
            <g key={i}>
              <line
                x1={P.l} x2={W - P.r}
                y1={P.t + innerH * (1 - f)} y2={P.t + innerH * (1 - f)}
                stroke="#23232a" strokeDasharray="2 4"
              />
              <text x={P.l - 8} y={P.t + innerH * (1 - f) + 4} fill="#6b7280" fontSize="10" textAnchor="end">
                {Math.round(max * f)}
              </text>
            </g>
          ))}

          {xTicks.map((i) => (
            <text key={i} x={P.l + i * stepX} y={H - 8} fill="#6b7280" fontSize="10" textAnchor="middle">
              {dateLabel(i, n)}
            </text>
          ))}

          <path d={areaPath} fill="url(#dx-area-grad)" />
          <path d={linePath} fill="none" stroke={accent} strokeWidth="2" />
          {pts.map((p, i) => (
            <circle
              key={i}
              cx={p[0]} cy={p[1]}
              r={i === pts.length - 1 ? 4 : 2.5}
              fill={accent} stroke="#17171a" strokeWidth="2"
            />
          ))}
        </svg>
      </div>
    </section>
  );
}

const QUICK_ACTIONS = [
  { id: 'blog',    Icon: I.blog,    title: 'Blog',                  desc: 'Share local content on a blog',       color: '#3b82f6', action: 'blog', comingSoon: true },
  { id: 'ai',     Icon: I.sparkle, title: 'AI Website Generator',  desc: 'Generate complete websites with AI',  color: '#8b5cf6', action: 'ai', comingSoon: true },
  { id: 'nav',    Icon: I.menu,    title: 'Navigation Menu',        desc: 'Personalize your navigation',         color: '#10b981', action: 'nav' },
  { id: 'landing',Icon: I.layout,  title: 'Landing Page',          desc: 'Build custom landing pages',          color: '#f59e0b', action: 'editor' },
  { id: 'org',    Icon: I.info,    title: 'Organization Info',      desc: 'Customize your business profile',     color: '#ec4899', action: 'org' },
];

function QuickActions({ onOpenEditor, onOpenAIGenerator, onOpenNavSettings, onOpenSettings }) {
  const handleAction = (action) => {
    if (action === 'editor' || action === 'landing') onOpenEditor?.();
    else if (action === 'ai') onOpenAIGenerator?.();
    else if (action === 'nav') onOpenNavSettings?.();
    else if (action === 'org') onOpenSettings?.();
  };

  return (
    <aside className="dx-card dx-quick-actions">
      <div className="dx-card-h">
        <div>
          <h2>Quick Actions</h2>
          <p className="dx-card-sub">Jump right in</p>
        </div>
      </div>
      <div className="dx-qa-list">
        {QUICK_ACTIONS.map(({ id, Icon, title, desc, color, badge, action, comingSoon }) => (
          <button
            key={id}
            className={`dx-qa-item${comingSoon ? ' dx-qa-item-disabled' : ''}`}
            onClick={() => { if (!comingSoon) handleAction(action); }}
            disabled={comingSoon}
            aria-disabled={comingSoon}
          >
            <div className="dx-qa-icon" style={{ background: color + '1f', color }}>
              <Icon />
            </div>
            <div className="dx-qa-meta">
              <div className="dx-qa-title">
                {title}
                {badge && <span className="dx-qa-badge">{badge}</span>}
                {comingSoon && <span className="dx-qa-badge dx-qa-badge-soon">COMING SOON</span>}
              </div>
              <div className="dx-qa-desc">{desc}</div>
            </div>
            {!comingSoon && <I.arrowRight className="dx-qa-arrow" />}
          </button>
        ))}
      </div>
    </aside>
  );
}

function PagesPerf({ dashboardData, domain }) {
  const accent = '#3b82f6';
  const pages = dashboardData?.topPages || [];
  const maxViews = Math.max(...pages.map((p) => p.views || 0), 1);

  return (
    <section className="dx-card">
      <div className="dx-card-h">
        <div>
          <h2>Top pages</h2>
          <p className="dx-card-sub">By page views, all time</p>
        </div>
        <button className="dx-icon-btn"><I.filter /></button>
      </div>
      <div className="dx-pages-list">
        {pages.length === 0 ? (
          <p className="dx-chip-empty">No page view data yet</p>
        ) : pages.map((p) => (
          <div key={p.url} className="dx-page-row">
            <div>
              <div className="dx-page-title">{p.title || p.url}</div>
              <div className="dx-page-path">{domain}<span>{p.url}</span></div>
            </div>
            <div className="dx-page-bar-wrap">
              <div
                className="dx-page-bar"
                style={{ width: `${(p.views / maxViews) * 100}%`, background: `linear-gradient(90deg, ${accent}66, ${accent})` }}
              />
            </div>
            <div className="dx-page-views">{p.views.toLocaleString()}</div>
          </div>
        ))}
      </div>
    </section>
  );
}

// ─── Main export ──────────────────────────────────────────────────────────────
export default function DashboardOverview({
  dashboardData,
  user,
  currentSubdomain,
  analyticsTimeRange,
  onTimeRangeChange,
  onOpenEditor,
  onOpenAIGenerator,
  onOpenNavSettings,
  onOpenSettings,
}) {
  return (
    <div className="dx-dashboard">
      <div className="dx-content">
        <SiteCard
          dashboardData={dashboardData}
          user={user}
          currentSubdomain={currentSubdomain}
        />

        <div className="dx-grid-two">
          <Analytics
            dashboardData={dashboardData}
            analyticsTimeRange={analyticsTimeRange}
            onTimeRangeChange={onTimeRangeChange}
          />
          <QuickActions
            onOpenEditor={onOpenEditor}
            onOpenAIGenerator={onOpenAIGenerator}
            onOpenNavSettings={onOpenNavSettings}
            onOpenSettings={onOpenSettings}
          />
        </div>

        <div className="dx-grid-wide">
          <PagesPerf dashboardData={dashboardData} domain={dashboardData?.websiteInfo?.domain || 'your site'} />
        </div>
      </div>
    </div>
  );
}
